import React from "react";


export function getComparableText(text){
  return text.toLowerCase().replaceAll(' ', '')
}

export function getPurchaseNameSummary(purchase) {
  // console.log(purchase)
  if(purchase.length > 1){
    return `${purchase[0].name} 외 ${(purchase.length - 1)}개`;
  }else{
    return purchase[0].name;
  }
}

export function getPurchaseNameForDownload(purchase) {
  // console.log(purchase)
  if(purchase.length > 1){
    let text = ''
    for(const p of purchase){
      text += `${purchase[0].name} ${purchase[0].count}개 / `
    }
    return text;
  }else{
    return purchase[0].name;
  }
}

export function getWarehouseNameFromState(centerId, warehouseState) {
  if(warehouseState && warehouseState.data && warehouseState.data.results){
    for (let warehouse of warehouseState.data.results){
      if(warehouse.id === centerId){
        return warehouse.name;
      }
    }
  }
  return '?';
}

// export function getWarehouseName(centerId, warehouses) {
//   if(warehouses){
//     for (let warehouse of warehouses){
//       if(warehouse.id === centerId){
//         return warehouse.name;
//       }
//     }
//   }
//   return '?';
// }

// export function getWarehouseName(value) {
//   if(value === 1){
//     return "서초"
//   }else if(value === 2){
//     return "역삼"
//   }
//   return "?"
// }

export function getMultilineTextToHtml (txt) {
    let text = String(txt).split("\n");
    let resultTag = '<div style="text-align:center">';
    for (let i = 0; i < text.length; i++) {
      resultTag += text[i].toLocaleString('ko-KR');
      if (i === text.length - 1) break;
      resultTag += '<br/>';
    }
    resultTag += '</div>';
    //    console.log("RET_TAG:", resultTag);
    return (resultTag);
  }